import { updatesData } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-200 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
            实时快讯追踪
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            24小时不间断更新，最新今日大瓜一手掌握
          </p>
          <div className="relative pl-8 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-0.5 before:bg-secondary-200">
            {updatesData.map((update) => (
              <div key={update.id} className="relative mb-5 last:mb-0">
                <div className="absolute -left-[22px] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-2 ring-background-50"></div>
                <div className="flex items-start gap-3 flex-wrap">
                  <span className="text-xs text-foreground-500 whitespace-nowrap pt-0.5">{update.time}</span>
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagStyles[update.tagType]}`}>
                    {update.tag}
                  </span>
                  <p className="text-sm text-foreground-800 leading-relaxed flex-1 min-w-0">
                    {update.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}